module.exports = __webpack_public_path__ + "img/stamp-fishing-tourney.4cf96805.png";